import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { LoginService } from './login.service';
import { log } from './decorators/log.decorator';

@Injectable({
    providedIn: 'root'
})
export class TrackingService {
    constructor(
        private http: HttpClient,
        private loginService: LoginService
    ) {}

    @log() markContentAsOpened(assignmentId: number): Observable<boolean> {
        return this.http.post<boolean>(
            `/users/${this.loginService.getUser().id}/assignments/${assignmentId}/tracking`,
            { status: 'opened' }
        );
    }

    @log() resetForcedStatus(assignmentId: number): Observable<any> {
        return this.http.post(
            `/users/${this.loginService.getUser().id}/assignments/${assignmentId}/tracking`,
            {
                forcedStatus: 'cancel'
            }
        );
    }

    @log() markContentAsCompleted(assignmentId: number): Observable<any> {
        return this.http.post(
            `/users/${this.loginService.getUser().id}/assignments/${assignmentId}/tracking`,
            {
                status: 'completed'
            }
        );
    }
}
